import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from "@angular/router";
import {Observable} from "rxjs";
import {Product} from './product';
import {ProductService} from './product.service';
import * as fromStore from "../../store";
import {filter, switchMap} from "rxjs/operators";
import {Store} from "@ngrx/store";

@Injectable()
export class ImageOptimizerPluginResolver implements Resolve<Product|null> {

  constructor(
    private _productService: ProductService,
    private _store: Store<fromStore.DbStoreState>
  ) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any>|Promise<any>|any {
    return new Promise((resolve: Function, reject: Function): void => {
      const websiteId: number = route.parent.data && route.parent.data['website'] ? route.parent.data['website'].id : route.parent.parent.data['website'].id;
      this._store.select(fromStore.getWebsitePluginsLoaded(websiteId))
        .pipe(
          filter((loaded: boolean) => loaded),
          switchMap(() => this._store.select(fromStore.getWebsiteImageOptimizerPlugin(websiteId)))
        )
        .subscribe((imageOptimizerPlugin) => {
          if (imageOptimizerPlugin) {
            resolve(imageOptimizerPlugin);
          }
          else {
            resolve(null);
          }
        });
    });
  }

}
